export default __webpack_public_path__ + "static/media/G.86847ee0.png";